export default __webpack_public_path__ + "static/media/lock.9d4b7cd2.svg";